import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import QRCode from 'qrcode.react';
import Barcode, { BarcodeProps } from 'react-barcode';

import { couponCodeTypesQuery } from '../../queries/coupon';

const CODE_TYPES = {
  TEXT: 'TEXT',
  QR: 'QR',
};

function stripLegacyQrPrefix(value) {
  if (typeof value !== 'string') return '';
  return value.replace(/^QR:/, '');
}

function CouponCodePreview({ coupon }) {
  const { data } = useQuery(couponCodeTypesQuery);

  const code = useMemo(() => {
    const raw = coupon?.code;
    if (raw === null || raw === undefined) return null;
    const trimmed = String(raw).trim();
    return trimmed.length > 0 ? trimmed : null;
  }, [coupon?.code]);

  const codeType = useMemo(() => {
    const raw = coupon?.codeType;
    return (raw === null || raw === undefined || String(raw).trim() === '')
      ? CODE_TYPES.TEXT
      : String(raw);
  }, [coupon?.codeType]);

  const couponCodeTypes = useMemo(() => {
    // Same fallback as app: if we don't have the allowlist yet, treat only TEXT as known.
    return data?.couponCodeTypes ?? [CODE_TYPES.TEXT];
  }, [data]);

  if (!code) return null;

  const isNotBarCode = codeType === CODE_TYPES.QR || codeType === CODE_TYPES.TEXT;
  const isBarCode = couponCodeTypes?.includes(codeType) && !isNotBarCode;
  const generalCodeType = isBarCode
    ? 'BARCODE'
    : codeType === CODE_TYPES.QR
      ? CODE_TYPES.QR
      : CODE_TYPES.TEXT;

  const noteText =
    generalCodeType === 'BARCODE'
      ? 'Streckkoden visas först när kupongen aktiveras.'
      : generalCodeType === CODE_TYPES.QR
        ? 'QR-koden visas först när kupongen aktiveras.'
        : 'Koden visas först när kupongen aktiveras.';

  return (
    <div className="coupon-code-preview">
      <div className="coupon-code-preview-inner">
        {generalCodeType === CODE_TYPES.QR && (
          <QRCode
            value={stripLegacyQrPrefix(code)}
            size={120}
            renderAs="svg"
            includeMargin={false}
          />
        )}

        {generalCodeType === 'BARCODE' && (
          <Barcode
            value={code}
            format={codeType as BarcodeProps['format']}
            height={45}
            width={1.5}
            fontSize={16}
            background="transparent"
          />
        )}

        {generalCodeType === CODE_TYPES.TEXT && (
          <span className="coupon-code-text">{code}</span>
        )}
      </div>

      <small className="coupon-code-preview-note">{noteText}</small>
    </div>
  );
}

export default CouponCodePreview;


